import PmsSearchBar from '@/components/PmsSearchBar'
import PmsSearchItem from '@/components/PmsSearchItem'
import Vue from 'vue';
// eslint-disable-next-line no-undef
const contexts = require.context('./', true, /\.vue$/);
contexts.keys().forEach((component) => {
  const componentEntity = contexts(component).default;
  if (!componentEntity.ignore) {
    // 使用内置的组件名称 进行全局组件注册
    Vue.component(componentEntity.name, componentEntity);
  }
});
import { openLoading, closeLoading } from './v-loading';
import Print from './v-print';
import uweb from 'vue-uweb';
import confirm from './v-confirm';
import { getClassNameByLanguage } from '@/utils/index';

const install = function (Vue) {
  if (install.installed) return;
  Vue.$openLoading = Vue.prototype.$openLoading = openLoading;
  Vue.$closeLoading = Vue.prototype.$closeLoading = closeLoading;
  Vue.$print = Vue.prototype.$print = Print;
  Vue.$uweb = Vue.prototype.$uweb = uweb;
  Vue.$confirm = Vue.prototype.$confirm = confirm;
  Vue.$getClassNameByLanguage = Vue.prototype.$getClassNameByLanguage = getClassNameByLanguage;

  Vue.component('p-button', () => import('@/components/common/p-button'));
  Vue.component('PmsSearchBar', PmsSearchBar);
  Vue.component('PmsSearchItem', PmsSearchItem);
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export {
  install as default,
  openLoading,
  closeLoading,
  Print,
  uweb,
  confirm,
  getClassNameByLanguage,
};
